import React, { useEffect, useState } from 'react';
import { MktAccordionTab } from './AccordionTab';
import clsx from 'clsx';
import { AccordionImageWrapper } from './AccordionImageWrapper/AccordionImageWrapper';

export enum MktAccordionType {
  default = 'default',
  simple = 'simple',
}

export enum MktAccordionVariant {
  light = 'light',
  dark = 'dark',
}

interface MktAccordionTabProp {
  title: string;
  description: string;
  image: string;
  redirectUrl?: string;
}

interface MktAccordionProps {
  reverse?: boolean;
  tabs: MktAccordionTabProp[];
  variant: `${MktAccordionVariant}`;
  disabledMobileImage?: boolean;
  type?: `${MktAccordionType}`;
}

export const MktAccordion: React.FC<MktAccordionProps> = ({
  reverse = false,
  tabs,
  variant,
  disabledMobileImage = false,
  type = 'default',
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const [renderRdy, setRenderRdy] = useState(false);

  const activeTabHandler = (currentTab: number) => {
    setActiveTab(currentTab);
  };

  useEffect(() => {
    const timeOutRender = setTimeout(() => {
      return setRenderRdy(true);
    }, 250);

    return () => clearTimeout(timeOutRender);
  }, []);

  return (
    <section
      className={clsx(
        'whl-flex whl-h-auto whl-items-start whl-justify-center whl-py-6 lg:whl-max-w-[1200px] lg:whl-justify-between lg:whl-gap-5 lg:whl-px-4 lg:whl-py-7 2xl:whl-flex 2xl:whl-justify-between',
        `${renderRdy ? 'whl-opacity-100' : 'whl-opacity-0'}`,
      )}
    >
      <div
        className={clsx(
          `${
            reverse ? 'whl-order-2' : 'whl-order-1'
          } lg:whl-w-[50%] xl:whl-w-[580px]`,
          {
            'whl-w-full lg:whl-w-full xl:whl-w-full':
              type == MktAccordionType.simple,
          },
        )}
      >
        {tabs.map((tab: MktAccordionTabProp, i) => {
          return (
            <MktAccordionTab
              {...tab}
              key={tab.title}
              isLast={i + 1 === tabs.length}
              isActive={i === activeTab}
              onClick={() => activeTabHandler(i)}
              variant={variant}
              disabledMobileImage={disabledMobileImage}
              type={type}
            />
          );
        })}
      </div>
      {type === MktAccordionType.default && (
        <AccordionImageWrapper reverse={reverse}>
          <img
            className={`whl-block whl-object-contain lg:whl-h-full lg:whl-w-full xl:whl-h-[530px] xl:whl-w-[530px]`}
            src={tabs[activeTab].image}
            alt={tabs[activeTab].title}
          />
        </AccordionImageWrapper>
      )}
    </section>
  );
};
